"use client";

import { cn } from "@heroui/theme";
import useEmblaCarousel from "embla-carousel-react";
import Image from "next/image";

import { About4, About5, About6, About7 } from "@/public/assets";

const MeetOurTeam = () => {
  const team = [
    {
      name: "Charles Emmanuel",
      role: "CEO",
      image: About4.src,
      className: "object-[50%_18%] sm:object-[50%_16%] lg:object-[50%_18%]",
    },
    {
      name: "Idowu Shittu ",
      role: "COO",
      image: About5.src,
      className: "object-[50%_12%] sm:object-[50%_10%] lg:object-[50%_12%]",
    },
    {
      name: "Grace Oyebamiji",
      role: "Finance",
      image: About6.src,
      className:
        "scale-[215%] object-[50%_-18%] sm:scale-[205%] sm:object-[50%_-20%] lg:scale-[200%] lg:object-[50%_-12%]",
    },
    {
      name: "Oderinde Caleb",
      role: "Product",
      image: About7.src,
      className: "object-[50%_24%] sm:object-[50%_22%] lg:object-[50%_24%]",
    },
  ];

  const [emblaRef] = useEmblaCarousel({
    align: "start",
    loop: false,
  });

  return (
    <section className="pt-15 pb-14 max-sm:pt-10 max-sm:pb-10">
      <div className="lg:px-28 px-6  max-w-screen-2xl mx-auto ">
        <div
          className="text-green-600 text-xs font-medium leading-4 mb-3"
          data-aos="fade-up"
        >
          Meet our team
        </div>

        <div
          className=" mb-[46px] text-2xl font-medium leading-8 max-w-lg tracking-[-0.16px] text-neutral-950 dark:text-white max-sm:text-lg max-sm:leading-7 max-sm:mb-8"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          Cotton is powered by builders, operators, and problem-solvers who
          believe good systems make great work possible.
        </div>
      </div>

      <div
        className="lg:px-28 px-6  max-w-screen-2xl mx-auto"
        data-aos="fade-left"
      >
        <div ref={emblaRef} className="w-full overflow-hidden">
          <div className="flex gap-4 pr-12 max-sm:gap-3 max-sm:pr-3">
            {team.map((item, index) => {
              return (
                <div
                  key={index}
                  className={`relative shrink-0 w-1/4 h-[320px] rounded-3xl overflow-hidden transition-all duration-500 sm:max-lg:w-[304px] max-sm:w-[70%] max-sm:h-[260px]`}
                >
                  {item.image && (
                    <Image
                      fill
                      alt={item.name}
                      className={cn("object-cover", item.className)}
                      src={item.image}
                    />
                  )}

                  {/* Gradient Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />

                  {/* Text */}
                  <div className="absolute bottom-4 left-4 text-white max-sm:bottom-3 max-sm:left-3">
                    <p
                      className="text-lg font-medium leading-6 tracking-[-0.27px] mb-1"
                      style={{
                        fontFeatureSettings:
                          "'ss11' on, 'cv09' on, 'liga' off, 'calt' off",
                      }}
                    >
                      {item.name}
                    </p>
                    <p
                      className="text-sm font-normal leading-5 tracking-[0.84px] uppercase"
                      style={{
                        fontFeatureSettings:
                          "'ss11' on, 'cv09' on, 'liga' off, 'calt' off",
                      }}
                    >
                      {item.role}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MeetOurTeam;
